import React from "react";
import PropTypes from "prop-types";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  DialogContentText,
  Button,
  Box,
  Typography,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const CustomModel = (props) => {
  const { children } = props;

  return (
    <Dialog
      open={props.open}
      onClose={props.handleClose}
      fullScreen={props?.fullScreen}
      maxWidth={props?.width || "md"}
      fullWidth
      onAddCandidate={props?.onAddCandidate}
    >
      {/* <DialogTitle
        color="primary"
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        {/* {props?.title} 
        <Typography variant="h6" component="div">{props?.title}</Typography>

        <IconButton onClick={props.handleDialog} edge="end" color="inherit">
          <CloseIcon />
        </IconButton>
      </DialogTitle> */}
      <DialogTitle
        color="primary"
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography variant="h6" component="div">{props?.title}</Typography>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          {props.onAddCandidate && (
            <Button
              onClick={props.onAddCandidate}
              variant="outlined"
              sx={{ mr: 0.5, textTransform: "none", minWidth: 0, px: 1.5 }}
            >
              Add Candidate
            </Button>
          )}
          <IconButton onClick={props.handleDialog} edge="end" color="inherit">
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent dividers={"true"}>
        <DialogContentText>{props?.message}</DialogContentText>

        <Box sx={{ p: 1 }}>
          {!children ? (
            <Typography variant="body2">No Data Found</Typography>
          ) : (
            children
          )}
        </Box>
      </DialogContent>
      {props.action ? (
        <DialogActions>
          {props?.actions?.map((action) => (
            <Button key={action.label} onClick={action.onClick}>
              {action.label}
            </Button>
          ))}
        </DialogActions>
      ) : null}
    </Dialog>
  );
};

CustomModel.propTypes = {
  open: PropTypes.bool,
  actions: PropTypes.array || PropTypes.any,
  title: PropTypes.string,
  message: PropTypes.string,
  handleClose: PropTypes.func,
  fullScreen: PropTypes.string,
};

export default CustomModel;
